/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menufileunsupported2Inputs */

const en_menufileunsupported2 = /** @type {(inputs: Menufileunsupported2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: we cannot read this format. Upload a photo or a PDF.`)
};

const de_menufileunsupported2 = /** @type {(inputs: Menufileunsupported2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: Dieses Format können wir nicht lesen. Lade ein Foto oder ein PDF hoch.`)
};

/**
* | output |
* | --- |
* | "{name}: we cannot read this format. Upload a photo or a PDF." |
*
* @param {Menufileunsupported2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufileunsupported2 = /** @type {((inputs: Menufileunsupported2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufileunsupported2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufileunsupported2(inputs)
	return de_menufileunsupported2(inputs)
});
export { menufileunsupported2 as "menuFileUnsupported" }